import AppConstants from '../constants/app-constants'
import AppDispatcher from '../dispatcher/app-dispatcher'


var SelectorActions = {
    addOrderItem: function (item) {
        AppDispatcher.handleViewAction({
            actionType: AppConstants.ADD_ITEM,
            item: item
        });
    },

    /**
     * @param {OpeOrderItem[]} items
     */
    addOrderItems: function (items) {
        AppDispatcher.handleViewAction({
            actionType: AppConstants.ADD_ITEMS,
            items: items
        });
    },

    /**
     * @param {OpeOrderItem} item
     */
    removeOrderItem: function (item) {
        AppDispatcher.handleViewAction({
            actionType: AppConstants.REMOVE_ITEM,
            item: item
        });
    },
    removeOrderItemsByImageId: function (imageId) {
        AppDispatcher.handleViewAction({
            actionType: AppConstants.REMOVE_ITEMS_BY_IMAGEID,
            imageId: imageId
        });
    },

    duplicateOrderItem: function (itemId) {
        AppDispatcher.handleViewAction({
            actionType: AppConstants.DUPLICATE_ITEM,
            itemId: itemId
        });
    },

    setItemQuantity: function (itemId, quantity) {
        AppDispatcher.handleViewAction({
            actionType: AppConstants.SET_ITEM_QUANTITY,
            itemId: itemId,
            quantity: quantity
        });
    },
    setItemProduct: function (itemId, productId, productWidth, productHeight) {
        AppDispatcher.handleViewAction({
            actionType: AppConstants.SET_ORDER_ITEM_PRODUCT,
            itemId: itemId,
            productId: productId,
            productWidth: productWidth,
            productHeight: productHeight
        });
    },
    setItemImageFilterValue: function (itemId, filterName, value) {
        AppDispatcher.handleViewAction({
            actionType: AppConstants.SET_ITEM_IMAGE_FILTER,
            itemId: itemId,
            filterName: filterName,
            value: value
        });
    },
    setLowResWarning: function (itemId) {
        AppDispatcher.handleViewAction({
            actionType: AppConstants.SET_LOW_RES_WARNING,
            itemId: itemId
        });
    },

    removeLowResWarning: function (itemId) {
        AppDispatcher.handleViewAction({
            actionType: AppConstants.REMOVE_LOW_RES_WARNING,
            itemId: itemId
        });
    },

    setAutoCropWarning: function (itemId, giveWarning) {
        AppDispatcher.handleViewAction({
            actionType: AppConstants.SET_AUTO_CROP_WARNING,
            itemId: itemId,
            giveWarning: giveWarning
        });
    },

    setAutoCropWarningOverride: function (itemId, giveWarning) {
        AppDispatcher.handleViewAction({
            actionType: AppConstants.SET_AUTO_CROP_WARNING_OVERRIDE,
            itemId: itemId,
            giveWarning: giveWarning
        });
    },

    setLowResWarningOverride: function (itemId, giveWarning) {
        AppDispatcher.handleViewAction({
            actionType: AppConstants.SET_LOW_RES_WARNING_OVERRIDE,
            itemId: itemId,
            giveWarning: giveWarning
        });
    },

    removeLowResWarningOverride: function (itemId) {
        AppDispatcher.handleViewAction({
            actionType: AppConstants.SET_LOW_RES_WARNING_OVERRIDE,
            itemId: itemId,
            giveWarning: null
        });
    },

    removeAutoCropWarningOverride: function (itemId) {
        AppDispatcher.handleViewAction({
            actionType: AppConstants.SET_AUTO_CROP_WARNING_OVERRIDE,
            itemId: itemId,
            giveWarning: null
        });
    },

    toggleOrderBatchState: function (batchSelected) {
        AppDispatcher.handleViewAction({
            actionType: AppConstants.TOGGLE_BATCH_SELECTION,
            batchSelected: batchSelected
        });
    },

    toggleItemBatchState: function (item, inBatch) {
        AppDispatcher.handleViewAction({
            actionType: AppConstants.TOGGLE_ITEM_BATCH_STATE,
            item: item,
            inBatch: inBatch
        });
    },

    rotateImage: function (item, angle) {
        AppDispatcher.handleViewAction({
            actionType: AppConstants.ROTATE_IMAGE,
            item: item,
            angle: angle
        });
    },

    setItemCropPositionAndScale: function (item, scale, x, y) {
        AppDispatcher.handleViewAction({
            actionType: AppConstants.SET_CROP_POSITION_SCALE,
            item: item,
            scale: scale,
            x: x,
            y: y
        });
    },

    setCropScale: function (item, scale) {
        AppDispatcher.handleViewAction({
            actionType: AppConstants.SET_CROP_SCALE,
            item: item,
            scale: scale
        });
    },

    setItemImageTakenDate: function (item, date) {
        AppDispatcher.handleViewAction({
            actionType: AppConstants.SET_ITEM_IMAGE_TAKEN_DATE,
            item: item,
            date: date
        });
    },
    setUploadStatus: function (imageId, status) {
        AppDispatcher.handleViewAction({
            actionType: AppConstants.SET_ORDER_ITEM_UPLOAD_STATUS,
            imageId: imageId,
            status: status
        })
    }
};

export default SelectorActions;
